import { useTranslation } from 'react-i18next';
import OwnersTableActions from '../../actions/OwnersTableActions';

export default function OwnersColumns({ owners, handleEdit, handleRemove }) {
  const { t } = useTranslation(['tables', 'forms']);

  return [
    {
      dataIndex: 'name',
      header: t('name', { ns: 'tables' }),
    },
    {
      dataIndex: 'custom',
      header: t('actions', { ns: 'tables' }),
      render: (_, row) => {
        return (
          <OwnersTableActions
            owners={owners}
            row={row}
            handleEdit={handleEdit}
            handleRemove={handleRemove}
          />
        );
      },
    },
  ];
}
